// /src/pages/private/members/Academy.jsx

import React, { useState } from 'react';
import { useSecurity } from '../../../SecurityContext';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { useMemberAcademyCatalog } from './academyTools/hooks/useMemberAcademyCatalog';
import AcademyHeader from './academyTools/components/AcademyHeader';
import AcademyCourseSidebar from './academyTools/components/AcademyCourseSidebar';
import AcademyResourceCards from './academyTools/components/AcademyResourceCards';
import AcademyDocumentModal from './academyTools/components/AcademyDocumentModal';
import AcademyExamDisclaimerModal from './academyTools/components/AcademyExamDisclaimerModal';
import MemberCourseExamModal from './academyTools/components/MemberCourseExamModal';

export default function Academy() {
  const { userHasPermission } = useSecurity();
  const canViewAcademy = userHasPermission('private.navbar.academy', 'read');

  const {
    loading,
    error,
    courses,
    selectedCourseId,
    selectedCourse,
    setSelectedCourseId,
    refetch,
  } = useMemberAcademyCatalog({ enabled: canViewAcademy });

  const [activeDocument, setActiveDocument] = useState(null);
  const [examDisclaimerCourse, setExamDisclaimerCourse] = useState(null);
  const [activeExamCourse, setActiveExamCourse] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('card');

  const handleOpenDocument = (document) => {
    if (selectedCourse?.promotionGateLocked) return;
    setActiveDocument(document);
  };

  const handleOpenExamDisclaimer = (course) => {
    if (!course?.examRoomOpen) return;
    setExamDisclaimerCourse(course);
  };

  const handleConfirmExamDisclaimer = (course) => {
    setExamDisclaimerCourse(null);
    setActiveExamCourse(course);
  };

  if (!canViewAcademy) {
    return (
      <div className="private-pages">
        <div className="user-admin-container">
          <p className="no-permission">You do not have permission to view the academy.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="private-pages">
      <div className="user-admin-container">
        <section
          className="member-academy"
          data-resource="private.navbar.academy"
          data-action="read"
          data-description="Navbar → Academy"
        >
          <AcademyHeader
            searchTerm={searchTerm}
            onSearchTermChange={setSearchTerm}
            viewMode={viewMode}
            onViewModeChange={setViewMode}
          />

          {loading ? (
            <div className="member-academy__loading">
              <LoadingSpinner />
            </div>
          ) : null}

          {!loading && error ? <p className="error">{error}</p> : null}

          {!loading && !error ? (
            <div className="member-academy__shell">
              <div className="member-academy__layout">
                <AcademyCourseSidebar
                  courses={courses}
                  selectedCourseId={selectedCourseId}
                  onSelectCourse={setSelectedCourseId}
                  searchTerm={searchTerm}
                />
                <AcademyResourceCards
                  course={selectedCourse}
                  searchTerm={searchTerm}
                  viewMode={viewMode}
                  onOpenDocument={handleOpenDocument}
                  onOpenExamDisclaimer={handleOpenExamDisclaimer}
                />
              </div>
            </div>
          ) : null}

          <AcademyDocumentModal
            show={Boolean(activeDocument)}
            selectedDocument={activeDocument}
            onClose={() => setActiveDocument(null)}
          />

          <AcademyExamDisclaimerModal
            show={Boolean(examDisclaimerCourse)}
            course={examDisclaimerCourse}
            onCancel={() => setExamDisclaimerCourse(null)}
            onConfirm={handleConfirmExamDisclaimer}
          />

          <MemberCourseExamModal
            show={Boolean(activeExamCourse)}
            course={activeExamCourse}
            onClose={() => setActiveExamCourse(null)}
            onExamFinished={refetch}
          />
        </section>
      </div>
    </div>
  );
}
